export const accordionData = {
  pricingInfo: [
    {
      title: 'Fee breakdown explained',
      content: `
        <p>The following fees are the same regardless of the rate you choose:</p>
        <ul>
          <li>Origination fee or underwriting fee</li>
          <li>Services you cannot shop for</li>
          <li>Services you can shop for</li>
          <li>Taxes and other government fees</li>
          <li>Prepaid interest </li>
          <li>If you’re choosing to escrow:
            <ul>
              <li>Property taxes</li>
              <li>Home insurance</li>
            </ul>
          </li>
        </ul>
        <p>If you want to escrow your taxes and insurance, you’ll need to come to closing with money to fund the account for the next pay period, but don’t worry — you’ll get refunded by your current lender for your current escrow account.</p>
        <p>Things you should compare between the fee estimates on different rates are the following:</p>
        <ul>
          <li>Points</li>
          <li>Lender credits</li>
          <li>Summary of costs</li>
          <li>Summary of closing costs </li>
        </ul>
      `,
    },
    {
      title: 'How do points and lender credits work?',
      content: `
        <p>Points and lender credits work as opposite forces when looking at your rate options.</p>
        <p>Points let you pay more upfront in exchange for a lower interest rate. This means it takes longer to reach your break-even point from the cost of refinancing, but it can be a great option if you plan on staying in your home for a long time.</p>
        <p>Credits work in the opposite direction. Your lender pays for a portion of your closing costs in exchange for a higher rate. This can be a great option if you don’t plan on spending a long time in your home.</p>
        <p>Either way, it’s important to make sure you choose an option that matches your expected time in your home so you can make sure you reap the financial benefits of refinancing to offset the cost.</p>
      `,
    },
    {
      title: 'Can I change my rate choice after I lock?',
      content:
        'Yes! Our digital application flow gives you all of the flexibility without the hassle. If you know what you want, great! Just select the rate you want to lock. If you’re not sure which rate is the one for you, select your favorite and your loan officer can make any adjustments to your choice after you lock. Or, select Talk to an Expert and your loan officer will be notified that you’d like to talk to them about your options before you lock.',
    },
    {
      title: 'What factors affect my rate?',
      content:
        'Some factors that can impact your rate are your credit score, loan amount, property value, debt-to-income ratio, cash out, property use, and property type.',
    },
    {
      title: 'Term definitions',
      content: `
        <ul>
          <li><strong>Monthly payment:</strong> This represents your monthly principal plus interest. If you choose to escrow your taxes and insurance, your total estimated monthly payment.</li>
          <li><strong>Rate:</strong> Similar to other loans, this is how much you'll pay to borrow the money for your loan each year.</li>
          <li><strong>APR:</strong> APR (Annual Percentage Rate) is a percentage that represents the total cost of your loan over its term, expressed as a percentage. This is a combination of your interest rate, fees and upfront costs so you can easily compare the total cost of loans.</li>
        </ul>
      `,
    },
  ],
  bankrateCompareFAQ: [
    {
      title: 'What is this?',
      content:
        "This is a simple tool to quickly compare what you're currently paying for your mortgage with the thousands of offers we have available with our lending partners. If you give us your name and address only, we'll do a soft credit pull and retrieve property data on the address you gave us. If you upload a file containing your current mortgage information, we scan that file for the financial data we need to make a comparison.</p>",
    },
    {
      title: `What's a "soft credit pull" and why do you need to do it?`,
      content:
        "In order to find the best possible rates customized for you, we'll need accurate financial information. A soft credit pull retrieves your credit score, current mortgage rate estimates, and open accounts. This process does not affect your credit score.",
    },
    {
      title: "What if I can't find a better deal than my current mortgage?",
      content:
        "Depending on what your refinancing goals are, we almost certainly have a better offer available for you. In the highly unlikely event that we cannot find one that meets your needs, you can rest easy knowing you're getting a great deal already.",
    },
  ],
  bankratePricingInfo: [
    {
      title: 'How do points and lender credits work?',
      content: `
        <p>Points and lender credits work as opposite forces when looking at your rate options.</p>
        <p>Points let you pay more upfront in exchange for a lower interest rate. This means it takes longer to reach your break-even point from the cost of refinancing, but it can be a great option if you plan on staying in your home for a long time.</p>
        <p>Credits work in the opposite direction. Your lender pays for a portion of your closing costs in exchange for a higher rate. This can be a great option if you don’t plan on spending a long time in your home.</p>
        <p>Either way, it’s important to make sure you choose an option that matches your expected time in your home so you can make sure you reap the financial benefits of refinancing to offset the cost.</p>
      `,
    },
    {
      title: 'What factors affect my rate?',
      content:
        'Some factors that can impact your rate are your credit score, loan amount, property value, debt-to-income ratio, cash out, property use, and property type.',
    },
    {
      title: 'Term definitions',
      content: `
        <ul>
          <li><strong>Monthly payment:</strong> This represents your monthly principal plus interest. If you choose to escrow your taxes and insurance, your total estimated monthly payment.</li>
          <li><strong>Rate:</strong> Similar to other loans, this is how much you'll pay to borrow the money for your loan each year.</li>
          <li><strong>APR:</strong> APR (Annual Percentage Rate) is a percentage that represents the total cost of your loan over its term, expressed as a percentage. This is a combination of your interest rate, fees and upfront costs so you can easily compare the total cost of loans.</li>
        </ul>
      `,
    },
  ],
}
